import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
// import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'

import { getName } from '@mangovoice/core'

const Colors = themeColorSectionKeys.TopNav.QueueControlButton

export const QueueControlButtonStyleValues = {
  menuWidth: '17.5rem',
}

export enum QueueControlButtonVariant {
  InQueue = 'InQueue',
  OutOfQueue = 'OutOfQueue',
  DoNotDisturb = 'DoNotDisturb',
  CustomOnline = 'CustomOnline',
  CustomAway = 'CustomAway',
}

const QueueControlButtonParts = [
  'menuHeader',
  'menuHeaderText',
  'button',
  'buttonContentsContainer',
  'textContainer',
  'label',
  'secondaryLabel',
  'chevronIcon',
] as const

const helpers = createMultiStyleConfigHelpers(QueueControlButtonParts)
export const QueueControlButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    menuHeader: {
      width: 'full',
      paddingX: '0.5rem',
      paddingTop: '0.5rem',
    },
    menuHeaderText: {
      textStyle: 'Body2_Bold',
    },
    button: {
      width: '11rem',
      height: '2.5rem',
      paddingLeft: '1.25rem',
      paddingRight: '1rem',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: '0',
      borderRadius: '6.25rem',
      cursor: 'pointer',
    },
    buttonContentsContainer: {
      alignItems: 'center',
      gap: '.5rem',
    },
    textContainer: {
      flexDirection: 'column',
    },
    label: {
      lineHeight: '0.875rem',
      maxWidth: '6.25rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: '600',
    },
    secondaryLabel: {
      textStyle: textStyleKeys.Body3,
      lineHeight: '0.875rem',
    },
    chevronIcon: {
      boxSize: '0.75rem',
    },
  },
  variants: {
    [QueueControlButtonVariant.InQueue]: {
      button: {
        backgroundColor: Colors.OutOfQueue.Background,
        _hover: {
          backgroundColor: Colors.OutOfQueue.Hover.Background,
        },
      },
      label: {
        textStyle: textStyleKeys.Body2,
        color: Colors.OutOfQueue.Label.FontColor,
      },
      secondaryLabel: {
        color: Colors.OutOfQueue.SecondaryLabel.FontColor,
      },
      chevronIcon: {
        color: Colors.OutOfQueue.ChevronIcon.FontColor,
      },
    },
    [QueueControlButtonVariant.OutOfQueue]: {
      button: {
        backgroundColor: Colors.OutOfQueue.Background,
        _hover: {
          backgroundColor: Colors.OutOfQueue.Hover.Background,
        },
      },
      label: {
        textStyle: textStyleKeys.Body2,
        color: Colors.OutOfQueue.Label.FontColor,
        fontWeight: '400',
      },
      secondaryLabel: {
        color: Colors.OutOfQueue.SecondaryLabel.FontColor,
      },
      chevronIcon: {
        color: Colors.OutOfQueue.ChevronIcon.FontColor,
      },
    },
    [QueueControlButtonVariant.DoNotDisturb]: {
      button: {
        backgroundColor: Colors.DoNotDisturb.Background,
        _hover: {
          backgroundColor: Colors.DoNotDisturb.Hover.Background,
        },
      },
      label: {
        textStyle: textStyleKeys.Body2_Semibold,
        color: Colors.DoNotDisturb.Label.FontColor,
      },
      secondaryLabel: {
        color: Colors.DoNotDisturb.SecondaryLabel.FontColor,
      },
      chevronIcon: {
        color: Colors.DoNotDisturb.ChevronIcon.FontColor,
      },
    },
    [QueueControlButtonVariant.CustomOnline]: {
      button: {
        backgroundColor: Colors.OutOfQueue.Background,
        _hover: {
          backgroundColor: Colors.OutOfQueue.Hover.Background,
        },
      },
      label: {
        textStyle: textStyleKeys.Body2_Semibold,
        color: Colors.OutOfQueue.Label.FontColor,
      },
      secondaryLabel: {
        color: Colors.OutOfQueue.SecondaryLabel.FontColor,
      },
      chevronIcon: {
        color: Colors.OutOfQueue.ChevronIcon.FontColor,
      },
    },
    [QueueControlButtonVariant.CustomAway]: {
      button: {
        backgroundColor: Colors.DoNotDisturb.Background,
        _hover: {
          backgroundColor: Colors.DoNotDisturb.Hover.Background,
        },
      },
      label: {
        textStyle: textStyleKeys.Body2_Semibold,
        color: Colors.DoNotDisturb.Label.FontColor,
      },
      secondaryLabel: {
        color: Colors.DoNotDisturb.SecondaryLabel.FontColor,
      },
      chevronIcon: {
        color: Colors.DoNotDisturb.ChevronIcon.FontColor,
      },
    },
  },
})

export const useQueueControlButtonStyle = (props: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof QueueControlButtonParts>(
    getName({ QueueControlButtonStyle }),
    props,
  )
}
